import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MobileMaxWidth } from '../../../../constants/responsive';

import $ from 'jquery';
import 'jquery-datetimepicker';
// Document: https://xdsoft.net/jqplugins/datetimepicker/

@Component({
  selector: 'sd-grid-date-picker-control',
  templateUrl: './grid-date-picker-control.component.html',
  styleUrls: ['./grid-date-picker-control.component.scss']
})
export class GridDatePickerControlComponent implements OnInit, AfterViewInit {
  private isMobile = window.innerWidth < MobileMaxWidth;
  private initialized = false;
  private pDate: any;
  @Input() type: 'datetime' | 'date' | 'time' = 'datetime';
  @Output() sdChange = new EventEmitter();
  date: string;

  @Input() set model(val: any) {
    if (!Date.isDate(val)) {
      this.pDate = null;
    } else {
      if (this.type === 'datetime') {
        this.pDate = this.datePipe.transform(val, 'dd/MM/yyyy HH:mm');
      } else if (this.type === 'date') {
        this.pDate = this.datePipe.transform(val, 'dd/MM/yyyy');
      } else {
        this.pDate = this.datePipe.transform(val, 'HH:mm');
      }
    }
    if (this.initialized) {
      this.onChanges();
    }
    this.ref.detectChanges();
  }
  @Output() modelChange = new EventEmitter();

  @ViewChild('control') control: ElementRef;
  constructor(
    private ref: ChangeDetectorRef,
    private datePipe: DatePipe) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.onChanges();
    this.initialized = true;
    this.setOption();
  }

  onFocus = () => {
    if (this.isMobile) {
      // tslint:disable-next-line: deprecation
      $(this.control.nativeElement).blur();
    }
  }

  private onChanges = () => {
    this.date = this.pDate;
  }

  private setOption() {
    if (this.initialized) {
      ($(this.control.nativeElement) as any).datetimepicker({
        datepicker: this.type === 'datetime' || this.type === 'date',
        timepicker: this.type === 'datetime' || this.type === 'time',
        format: this.type === 'datetime' ? 'd/m/Y H:i' : (this.type === 'date' ? 'd/m/Y' : 'H:i'),
        step: 15,
        scrollMonth: false,
        scrollTime: false,
        scrollInput: false,
        onChangeDateTime: (date: any) => {
          if (!date && !this.date) {
            return;
          }
          date = Date.toFormat(date, 'dd/MM/yyyy HH:mm');
          if (!this.equal(date, this.date)) {
            this.model = this.parse(date);
            this.modelChange.emit(this.parse(date));
            this.sdChange.emit(this.parse(date));
            this.ref.detectChanges();
          }
        }
      });
    }
  }

  private parse(date: any) {
    if (this.type === 'date') {
      return Date.parseFrom(date, 'dd/MM/yyyy');
    } else if (this.type === 'time') {
      return Date.parseFrom(date, 'HH:mm');
    }
    return Date.parseFrom(date, 'dd/MM/yyyy HH:mm');
  }
  private equal(date1: any, date2: any) {
    return Date.equal(this.parse(date1), this.parse(date2));
  }
}
